import { render, staticRenderFns } from "./BikyConfigHeader.vue?vue&type=template&id=37740e90&scoped=true&"
import script from "./BikyConfigHeader.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigHeader.vue?vue&type=style&index=0&id=37740e90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37740e90",
  null
  
)

export default component.exports